import React from 'react';
import Protection from './Protection';
import config from "../../config";

const Protections = ({ product }) => {
	let ulIcon;
	let etlIcon;
	let fire_protection_system;
	let protection_section;
	let classification_section;

	if (product.ulIcon === '1') {
		ulIcon = (
			<li>
				<img
					src={ require('../../resources/img/icons/UL-logo.png') }
					alt="UL Fire Endurance"
				/>
			</li>
		);
	}

	if (product.etlIcon === '1') {
		etlIcon = (
			<li>
				<img
					src={ require('../../resources/img/icons/ETL-logo.png') }
					alt="ETL Verified Endurance"
				/>
			</li>
		);
	}

	// If it is a Fire Bag, add extra Fire Protection System section, and override the Protection section
	if (product.overView.name===config.SKU_FIRE_BAG) {
		fire_protection_system = (
			<div className="row">
			<h3 className="title">
				Part of a Total Fire Protection System
			</h3>
				<div className="row protection-type fire-protection-system">
					<div className="protection-product col sm-4 align-center">
						<img src={ require('../../resources/img/firebag/level1.png') } alt="Fire Protection System" />
						<h4 className="protection-level">Level 1</h4>
						<h5 className="protection-description">Fire&#45;Resistant Document Bags</h5>
					</div>
					<div className="protection-product col sm-4 align-center">
						<img src={ require('../../resources/img/firebag/level2.png') } alt="Fire Protection System" />
						<h4 className="protection-level">Level 2</h4>
						<h5 className="protection-description">Portable Chest &amp; File Safes</h5>
					</div>
					<div className="protection-product col sm-4 align-center">
						<img src={ require('../../resources/img/firebag/level3.png') } alt="Fire Protection System" />
						<h4 className="protection-level">Level 3</h4>
						<h5 className="protection-description">XXL Capacity Fire Safes</h5>
					</div>
				</div>
			</div>
		)

		protection_section = (
				<ul className="callout">
					<li>
						<img
							className="icon"
							src={ require('../../resources/img/icons/fire-icon.png') }
							srcSet={ `${require('../../resources/img/icons/fire-icon@2x.png')} 2x` }
							alt="Fire Resistant"
						/>
						<h4 className="protection-name">Basic Fire Protection</h4>
						<p>Tested to endure brief fire exposure and keep interior temperatures safe for irreplaceable
							documents, cash, and small valuables; no document bag will survive a significant structure
							fire.</p>
					</li>
					<li>
						<img
							className="icon"
							src={ require('../../resources/img/icons/security-icon.png') }
							srcSet={ `${require('../../resources/img/icons/security-icon@2x.png')} 2x` }
							alt="Security Protection"
						/>
						<h4 className="protection-name">Maximum Protection</h4>
						<p>For maximum protection use in conjunction with a SentrySafe UL classified Fire Safe as part
							of a Total Fire Protection System.</p></li>
					<li>
						<img
							className="icon"
							src={ require('../../resources/img/icons/water-icon.png') }
							srcSet={ `${require('../../resources/img/icons/water-icon@2x.png')} 2x` }
							alt="Water Resistant"
						/>
						<h4 className="protection-name">Basic Water Protection</h4>
						<p>Fire Bag is not waterproof, but the outer layer will provide water resistance, keeping
							interior contents dry from a sprinkler system.</p>
					</li>
				</ul>
		)

	}
	else {
		// Non Fire Bag, generate protection_section from product.protections.

		const protection = product.protections.map(
			(protection,index) => <Protection key={ index } protection={ protection } />
		);
		protection_section = (
			<ul className="callout">
				{ protection }
			</ul>
		)
		classification_section = (
			<ul className="classification">
				{ ulIcon }
				{ etlIcon }
			</ul>
		)

	}

	return (
		<section className="protection-type" id="protection">
			{classification_section}
			{fire_protection_system}
			<div className="row">
				<h3 className="title">
					Top of the Line Protection
				</h3>
			</div>
			{protection_section}
		</section>
	);
};

export default Protections;


// WEBPACK FOOTER //
// ./src/pages/product/Protections.js